import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import YogaApp from './YogaApp'; // *** UPDATED: Added .tsx extension ***

// Create the root element (using the standard 'root' ID)
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Render the main YogaApp component
root.render(
  <React.StrictMode>
    <YogaApp />
  </React.StrictMode>
);
